<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">{{storeName}}培训管理平台</span>
      </div>
    </div>
    <div class="toptitle">
      <div class="ttleft">
        <div class="tt1">CME课程</div>
        <div class="tt2"
             v-if="info">剩余总学分{{info.sumScore}}分，为{{info.cardCount}}张面值{{info.score}}分的学分卡</div>
      </div>
      <!-- <div class="ttright"
           @click="toCredits(0)">
        学分管理查询
      </div> -->
    </div>
    <div class="top">
      <div class="tleft">
        <el-input placeholder="请输入项目名称"
                  size="small"
                  v-model="proName">
          <el-button slot="append"
                     @click="toSeach()"
                     icon="el-icon-search"></el-button>
        </el-input>
      </div>
      <!-- <div class="tright">
        <el-select v-model="type"
                   size="small"
                   @change="typeChange"
                   placeholder="请选择">
          <el-option v-for="item in typeList"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
      </div> -->
    </div>
    <div class="mid">
      <div class="courseBox"
           v-for="(item,index) in list"
           :key="index">
        <div class="cleft">
          <div class="imgBox">
            <img :src="item.pictureUrl"
                 referrerpolicy="no-referrer"
                 alt="">
          </div>
          <div class="infoBox">
            <div class="title">{{item.pname}}</div>
            <div class="remake">
              <div>项目编号：{{item.code}}</div>
              <div class="type">类别：{{item.attribute}}</div>
              <div class="time">学时：{{item.hours}}学时</div>
              <div>学分：{{item.category+' '+item.scoreCategory+' - '+item.score}}分</div>
              <!-- <div>{{item.startTime+' - '+item.endTime}}</div> -->
            </div>
          </div>
        </div>
        <div class="cright">
          <div class="schedules"></div>
          <div class="btnArr">
            <div class="statusOne"
                 @click="toShow(item.cid)">查看</div>
            <div @click="toCredits(item.cid)"
                 class="statusOne">学习情况</div>
          </div>
        </div>
      </div>
    </div>
    <div class="nolist"
         v-show="list.length==0">
      <img src="../../assets/img/no.png"
           alt="">
      <span>暂无CME课程</span>
    </div>
    <div class="pagination_Wrap">
      <pagination v-if="page.total>page.pageSize"
                  :total="page.total"
                  :limit="page.pageSize"
                  :page="page.currentPage"
                  @page-change="pageChange"></pagination>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      storeName: '',
      orgid: 0,
      page: {
        total: 0,
        pageSize: 6,
        currentPage: 1
      },
      //   typeList: [{
      //     value: 0,
      //     label: '全部'
      //   }, {
      //     value: 1,
      //     label: '已考核'
      //   }, {
      //     value: 2,
      //     label: '未考核'
      //   }],
      //   type: 0,
      proName: '',
      list: [],
      info: null
    };
  },
  created () {
    this.storeName = localStorage.getItem('storeName')
    this.orgid = Number(localStorage.getItem('storeId'))
    this.getList()
    this.getInfo()
  },
  methods: {
    pageChange (val) {
      if (this.page.currentPage == val) return
      this.page.currentPage = val;
      this.getList()
    },
    // typeChange (e) {
    //   this.type = index
    // }
    getList () {
      this.httphelper
        .get('/api/LearnProjectApi/GetOrgLearnProject', {
          orgId: this.orgid,
          proName: this.proName,
          page: this.page.currentPage,
          limit: this.page.pageSize
        })
        .then(res => {
          if (res.code == 200) {
            this.list = res.data
            this.page.total = res.totalcount
          }
        })
    },
    toShow (cid) {
      if (this.$cookies.get('token_chinagp')) {
        window.open('https://www.jumingedu.com/qkyx/courseDetails?id=' + cid + '&token=' + this.$cookies.get('token_chinagp'), "_blank")
      } else {
        window.open('https://www.jumingedu.com/qkyx/courseDetails?id=' + cid, "_blank")
      }
    },
    toSeach () {
      this.page.currentPage = 1
      this.getList()
    },
    getInfo () {
      this.httphelper
        .get('/api/LearnProjectApi/GetOrgCardConfigById', {
          orgId: this.orgid
        })
        .then(res => {
          if (res.code == 200) {
            this.info = res.data
          }
        })
    },
    toCredits (id) {
      if (id == 0) {
        this.$router.push({
          name: 'usCmeCredits'
        })
      } else {
        this.$router.push({
          name: 'usCmeCredits',
          query: {
            cid: id
          }
        })
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.toptitle {
    width: 100%;
    box-sizing: border-box;
    height: 57px;
    background: #f6f7fb;
    padding-left: 17px;
    margin: 30px 0 40px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 56px;
    .ttleft {
        display: flex;
        align-items: center;
        .tt1 {
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #0b8586;
        }
        .tt2 {
            font-size: 14px;
            font-family: Microsoft YaHei;
            margin-left: 36px;
        }
    }
    .ttright {
        height: 30px;
        line-height: 30px;
        padding: 0 10px;
        font-size: 14px;
        color: #0b8586;
        border: 1px solid #0b8586;
        border-radius: 15px;
        margin-right: 10px;
        cursor: pointer;
    }
}
.top {
    margin: 20px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .tleft {
        display: flex;
        align-items: center;
    }
}
.mid {
    display: flex;
    flex-direction: column;
    .courseBox {
        width: 100%;
        height: 195px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px 0;
        box-sizing: border-box;
        border-bottom: 5px solid #f8f8f8;
        .cleft {
            width: auto;
            height: 100%;
            display: flex;
            align-items: center;
            .imgBox {
                width: 250px;
                height: 100%;
                img {
                    width: 250px;
                    height: 100%;
                }
            }
            .infoBox {
                width: auto;
                height: 100%;
                margin-left: 30px;
                padding-top: 5px;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .title {
                    font-size: 16px;
                    color: #333;
                }
                .remake {
                    font-size: 14px;
                    color: #333;
                    line-height: 24px;
                }
            }
        }
        .cright {
            height: 100%;
            padding: 5px 0 6px 0;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .schedules {
                font-size: 14px;
                color: #217473;
                text-align: right;
            }
            .btnArr {
                display: flex;
                flex-direction: column;
                align-items: center;
                .statusOne {
                    border: 1px solid #217473;
                    color: #217473;
                    cursor: pointer;
                    width: 80px;
                    height: 26px;
                    box-sizing: border-box;
                    text-align: center;
                    line-height: 26px;
                    font-size: 12px;
                    border-radius: 14px;
                    margin-top: 10px;
                }
            }
        }
    }
}
.nolist {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 20px;
    margin-top: 80px;
    color: rgb(99, 99, 99);
    img {
        margin-bottom: 30px;
    }
}
</style>
